import { IMAGES } from "@/assets";

export const Logo = ({ dark = false, className = "" }) => (
  <img
    src={IMAGES.logoWordmark}
    alt="RISORICE"
    className={`w-auto object-contain select-none ${className}`}
    style={dark ? { filter: "brightness(0) invert(1)" } : undefined}
    data-testid="brand-logo"
  />
);
